(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alt-content-rtl-2rows"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript.closest('section');
  if(!root) return;

  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Video Autoplay Logic
  const vids = root.querySelectorAll('video');
  if(vids.length){
    if(prefersReduced){
      vids.forEach(v => { v.removeAttribute('autoplay'); try{ v.pause(); }catch(e){} });
    }
    if('IntersectionObserver' in window){
      const ioVid = new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          const v = entry.target;
          const shouldAutoplay = v.hasAttribute('autoplay') && v.muted;
          if(entry.isIntersecting){
            if(shouldAutoplay){ const p=v.play(); if(p&&p.catch) p.catch(()=>{}); }
          } else {
            if(!v.paused) v.pause();
          }
        });
      }, { threshold:.25 });
      vids.forEach(v => ioVid.observe(v));
    }
  }

  // Scroll Reveal
  const animRows = root.querySelectorAll('.acrt-anim-hidden');
  if(animRows.length > 0 && 'IntersectionObserver' in window && !prefersReduced){
    const ioAnim = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          entry.target.classList.add('acrt-anim-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    animRows.forEach(row => ioAnim.observe(row));
  }

  // Parallax
  const parallaxImgs = root.querySelectorAll('.acrt-parallax-img');
  if(parallaxImgs.length > 0 && !prefersReduced){
    window.addEventListener('scroll', () => {
      parallaxImgs.forEach(img => {
        const rect = img.closest('.acrt__row').getBoundingClientRect();
        const viewHeight = window.innerHeight;
        if (rect.top < viewHeight && rect.bottom > 0) {
          const distance = (viewHeight - rect.top) * 0.05;
          img.style.transform = `translateY(${distance}px) scale(1.1)`;
        }
      });
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
